<template>
  <div>
    <Button
      :icon="{ left: `edit` }"
      @click="show = true"
      >Edit
    </Button>
    <Modal
      :className="$style.modal"
      label="Edit User"
      v-model="show"
    >
      <Stack direction="column">
        <TextComponent>
          <b>Note: We cannot delete dictionaries here since we only transmit the difference, which
                   doesn't really work with deleting things...
          </b>
        </TextComponent>

        <vue-json-editor
            v-model="editedUser"
            :show-btns="false"
            :expandedOnStart="true"
        ></vue-json-editor>

        <Stack>
          <Button
              :icon="{ left: `save` }"
              :loading="loading"
              @click="submit"
          >Save
          </Button>
          <Button
              :loading="loading"
              @click="close"
          >Cancel
          </Button>
        </Stack>
      </Stack>
    </Modal>
  </div>
</template>

<script>
  import Button from '@hackthe6ix/vue-ui/Button';
  import Modal from '@hackthe6ix/vue-ui/Modal';
  import Select from '@hackthe6ix/vue-ui/Select';
  import Stack from '@hackthe6ix/vue-ui/Stack';
  import TextComponent from '@hackthe6ix/vue-ui/Text';
  import swal from 'sweetalert';
  import 'vue-awesome/icons/edit';
  import 'vue-awesome/icons/save';
  import vueJsonEditor from 'vue-json-editor';
  import { editObject } from '../../../../../utils/api';

  export default {
  name: 'EditApplicant',
  data() {
    return {
      loading: false,
      show: false,
      editedUser: {},
    };
  },
  props: {
    user: Object,
    updateUser: Function
  },
  methods: {
    close() {
      this.show = false;
    },
    /**
     * Recursively creates a dictionary with differing fields
     */
    getDiff(original, updated) {
      const isDict = (x) => typeof x === 'object' && x !== null;

      const out = {};

      let jointKeys = Object.keys(original).concat(Object.keys(updated));

      // Get unique keys
      jointKeys = jointKeys.filter((k, i) => jointKeys.indexOf(k) === i);

      let diff;

      for (const k of jointKeys) {
        if (isDict(updated[k])) {
          // Is dictionary

          diff = this.getDiff(original[k], updated[k]);

          if (diff) {
            out[k] = diff;
          }

        } else {
          // Is not a dictionary
          if (!!original !== !!updated || original[k] !== updated[k]) {
            out[k] = updated[k] === undefined ? null : updated[k];
          }
        }
      }

      return Object.keys(out).length ? out : undefined;
    },
    async submit() {
      swal({
        title: 'CONFIRM ACTION',
        text: 'Are you sure you want to update this user? Some changes may not be validated, so there is a risk of corruption or data loss.',
        icon: 'warning',
        buttons: true,
        dangerMode: true,
      }).then(async (confirm) => {
        if (confirm) {
          const result = await editObject(
            'user',
            {
              _id: this.user._id
            },
            this.getDiff(this.user, this.editedUser) || {}
          );

          if (result.success) {
            swal('Success', 'Your changes have been saved', 'success');
            this.updateUser(this.editedUser);

            this.show = false;
          } else {
            swal('Error', result.data, 'error');
          }


          this.loading = false;
        }
      });
    },
  },
  watch: {
    show() {
      this.editedUser = this.user;
    }
  },
  components: {
    TextComponent,
    vueJsonEditor,
    Button,
    Select,
    Stack,
    Modal,
  },
};
</script>

<style lang="scss" module src="./EditApplicant.module.scss" />
